import { css } from '@emotion/react';
import { styled } from '@mui/material/styles';

export const StyledUiTable = styled('div')(
  () => css`
    &.ui-table {
      margin-top: 20px;

      table {
        background-color: #ffffff !important;

        thead {
          background-color: unset !important;

          tr {
            background-color: #fff !important;

            th {
              background-color: #fff !important;
              padding: 12px 0;
              text-align: right;
              white-space: nowrap;

              &:first-child {
                border-radius: 0px 8px 8px 0 !important;
              }

              &:last-child {
                border-radius: 8px 0px 0px 8px !important;
              }
            }
          }
        }
      }

      .MuiPaper-root,
      .MuiPaper-elevation1 {
        box-shadow: 0px 3px 8px -1px rgba(50, 50, 71, 0.05),
          0px 0px 1px rgba(12, 26, 75, 0.24) !important;
        border-radius: 8px !important;
        -webkit-border-radius: 8px !important;
        -moz-border-radius: 8px !important;
        -ms-border-radius: 8px !important;
        -o-border-radius: 8px !important;
      }

      .MuiTableCell-root {
        font-family: inherit !important;
        border-bottom: unset !important;
        background-color: #ffffff !important;
      }

      .MuiCheckbox-root {
        margin: 0 15px;
      }

      .MuiTableRow-root.Mui-selected,
      .MuiTableRow-root.Mui-selected:hover {
        background-color: unset !important;
      }

      .MuiTableHead-root {
        border-radius: 20px;
      }

      .MuiTableCell-stickyHeader {
        background-color: unset !important;
        font-size: 1rem !important;
        font-weight: 800 !important;
        border-bottom: 1px solid #f5f5f5 !important;
      }
      .width-lg-900 {
        display: none;
      }
    }

    .ui-table-column-buttons {
      display: flex;
      justify-content: left;
      padding-left: 24px;
    }

    .ui-table-loading {
      .dot {
        text-align: initial !important;
      }
    }

    .ui-table-empty-data {
      &-label {
        display: flex;
        justify-content: center;
        color: #ccd5dc;
      }
    }

    .ui-table-options {
      display: flex;
      justify-content: space-between;

      .MuiFormControlLabel-root {
        margin-right: 0;
      }

      .MuiFormControlLabel-label {
        color: #aaaaaa !important;
      }
    }

    .ui-table-actions {
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
    }

    .ui-table-actions-item {
      background: #ffffff;
      border: 1px solid #eeeeee;
      border-radius: 6px;
      padding: 8px;
      margin: 0px 7px;
      cursor: pointer;
      display: flex;
      width: 18px;
      height: 18px;
      justify-content: center;
    }

    .ui-table-more-actions {
      .more-actions-more-info {
        top: 0px;
      }
    }

    @media (max-width: 1500px) {
      &.ui-table {
        .width-lt-1500 {
          display: none !important;
        }
      }
    }

    @media (max-width: 1200px) {
      &.ui-table {
        .width-lt-1200 {
          display: none !important;
        }
      }
    }

    @media (max-width: 900px) {
      &.ui-table {
        table {
          th:not(:nth-child(2)),
          td {
            padding-right: 5px !important;
          }

          .checkbox-column {
            display: none;
          }

          thead {
            tr {
              th {
                text-align: center !important;
              }
            }
          }

          tbody {
            tr {
              td {
                &:nth-child(2) {
                  padding-right: 24px !important;
                }
              }
            }
          }
        }

        .ui-table-options {
          justify-content: flex-end;
          margin-bottom: 12px;
          padding-top: 4px;

          label {
            display: none;
          }
        }

        .ui-table-actions {
          justify-content: flex-end;

          > *:not(:last-child) {
            display: none;
          }
        }

        .ui-table-column-buttons {
          display: none;
        }

        .width-lt-900 {
          display: none !important;
        }

        .width-lg-900 {
          display: table-cell !important;
        }

        .text-center-900 {
          text-align: center !important;
        }

        .text-right-900 {
          text-align: right !important;
          padding-right: 24px;
        }
      }
    }

    @media (max-width: 600px) {
      &.ui-table {
        .width-lt-600 {
          display: none !important;
        }

        .text-center-600 {
          text-align: center !important;
        }

        .text-right-600 {
          padding-right: 24px;
          text-align: right !important;
        }
      }
    }
  `
);
